import { dataFolderSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderSolid = /*#__PURE__*/createIcon(dataFolderSolid)
export default IconFolderSolid
